module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/kitchen-a7827c890163b046cc91c5f29b7a128b.svg";